import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DatabaseComponent } from './database/database.component';
import { DatabaseGroupInfoComponent } from './database/database-group-info/database-group-info.component';
import { ReportingComponent } from './reporting/reporting.component';
import { BatchStarterComponent } from '../features/batch-starter/components/batch-starter.component';
import { BannerManagerComponent } from '../features/banner-manager/components/banner-manager.component';
import { ToolsComponent } from './tools/tools.component';
import { LicensesComponent } from '../features/licenses/components/licenses.component';
import { MsLightComponent } from '../features/ms-light/components/ms-light.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'reporting',
    component: ReportingComponent,
  },
  {
    path: 'batch',
    component: BatchStarterComponent,
  },
  {
    path: 'licenses',
    component: LicensesComponent,
  },
  {
    path: 'banner',
    component: BannerManagerComponent,
  },
  {
    path: 'ms-light',
    component: MsLightComponent,
  },
  {
    path: 'tools',
    component: ToolsComponent,
  },
  {
    path: 'database/:node',
    component: DatabaseComponent,
  },
  {
    matcher: (url) => {
      if (url?.length === 4 && url?.[2]?.path === 'group-infos') {
        return {
          consumed: url,
          posParams: {
            groupId: new UrlSegment(url?.[3]?.path, {}),
          },
        };
      }
      return null;
    },
    component: DatabaseGroupInfoComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrivateRoutingModule {}
